import { render, staticRenderFns } from "./Question7.vue?vue&type=template&id=200d803f&scoped=true&"
import script from "./Question7.vue?vue&type=script&lang=js&"
export * from "./Question7.vue?vue&type=script&lang=js&"
import style0 from "./Question7.vue?vue&type=style&index=0&id=200d803f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d803f",
  null
  
)

export default component.exports